import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { Underline } from '../../../shared/underline/Underline';

import styles from './SignUpButton.styles.css';

interface ISignUpButtonProps {
    isSuccess: boolean;
}

export function SignUpButton (props: ISignUpButtonProps): ReactElement {
    const { isSuccess }: ISignUpButtonProps = props;
    let text: string = 'Sign up!';

    if (isSuccess) {
        text = 'Success!';
    }

    const buttonClassnames: string = classNames({
        'text-base font-bold focus:outline-none mb-1/2': true,
        'text-rebrand-navy-500': !isSuccess,
        'cursor-default text-black-50': isSuccess,
    });

    const button: ReactElement = (
        <button
            disabled={isSuccess}
            type="submit"
            className={buttonClassnames}
            role="button"
        >
            {text}
        </button>
    );

    if (isSuccess) {
        return (
            <div className="absolute top-2 right-2">
                {button}
            </div>
        );
    }

    return (
        <div>
            <Underline className={`${styles.signupButton} top-2 right-2`} animationStyle="underlineRemains" underlineHeight="large">
                {button}
            </Underline>
        </div>
    );
}
